import { useContext } from 'react';

import { SessionContext, SessionContextType } from '../../../js/app/contexts/SessionContext';
import type { ActingAsEntity } from '../utils/actingAsEntity';

type UseActingAsEntityResult = {
  actingAsEntity: ActingAsEntity | null;
  setActingAsEntity: (entity: ActingAsEntity | null) => void;
  isStaff: boolean;
};

export function useActingAsEntity(): UseActingAsEntityResult {
  const { user, actingAsEntity, setActingAsEntity } =
    useContext<SessionContextType>(SessionContext);
  return {
    actingAsEntity: actingAsEntity ?? null,
    setActingAsEntity: setActingAsEntity ?? (() => {}),
    isStaff: user?.user_type === 'staff',
  };
}
